module.exports = __webpack_public_path__ + "img/comfirme-person.d7c7f033.svg";